import { useContext } from 'react';
import { Context } from './Context';
export const useUserInvites = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useUserInvites must be used inside an UserInvitesProvider');
    }
    return context;
};
